import overlay from 'general/js/overlay/default-overlay';
import { MenuService } from './menu-service';

const menuService = new MenuService(overlay);

export {
    menuService
};
